function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from "prop-types";
import React, { Component } from "react";
import classnames from "classnames";
import { colors } from "@brandwatch/axiom-materials";
import renderFilter from "./_filter";
import "./Candytar.css";
const availableColors = Object.keys(colors.userDefinedGraphColors);

const defaultPickerFn = colors => colors[Math.floor(Math.random() * colors.length)];

export default class Candytar extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "componentDidMount", renderFilter);
  }

  render() {
    const {
      picker,
      color = picker(availableColors),
      size,
      initials
    } = this.props;
    const style = {
      height: size,
      width: size
    };
    const classes = classnames("ax-candytar", `ax-candytar--${color}`);
    const userInitials = initials.slice(0, 2).toUpperCase();
    /* eslint-disable max-len */

    const showSilhouette = /*#__PURE__*/React.createElement("path", {
      className: "ax-candytar__body",
      d: "M16 20c-4 0-7-3-7-7s3-7 7-7 7 3 7 7-3 7-7 7zM6 28.5c1.7-3.8 5.6-6.5 10-6.5 4.5 0 8.3 2.7 10 6.5C23.4 30.7 20 32 16 32s-7.3-1.3-10-3.5z",
      filter: "url(#ax-candytar__filter)"
    });
    const showInitials = /*#__PURE__*/React.createElement("text", {
      className: "ax-candytar__initials",
      textAnchor: "middle",
      x: "50%",
      y: "65%"
    }, userInitials);
    /* eslint-enable max-len */

    return /*#__PURE__*/React.createElement("svg", {
      className: classes,
      style: style,
      viewBox: "0 0 32 32"
    }, /*#__PURE__*/React.createElement("circle", {
      className: "ax-candytar__background",
      cx: "16",
      cy: "16",
      r: "16"
    }), initials ? showInitials : showSilhouette);
  }

}

_defineProperty(Candytar, "defaultProps", {
  picker: defaultPickerFn,
  initials: ""
});